export default {
  message: 'hello i18n!',
  menu: {
    document: 'Developer Docs',
  },
  page: {
    document: {
      privacyTip: 'This content is created by AiHouse. The information and data collected by AiHouse is only for research and the information provided will be protected in accordance with',
      privacyText: 'Privacy Policy',
      contactUs: 'Contact Us',
      contactUsTip: 'Please fill in your contact information and api requirements, we will contact you within 5 working days.',
      namePlaceholder: 'Name',
      nameTip: 'Please input your name',
      emailPlaceholder: 'Contact Email',
      emailTip1: 'Please input your E-mail',
      emailTip2: 'The input is not valid E-mail',
      phonePlaceholder: 'Contact Phone',
      phoneTip: 'Please input 6-15 valid mobile phones',
      countryPlaceholder: 'Your Home Country',
      countryTip: 'Please select your country',
      requirementPlaceholder: 'Your Requirement',
      requirementTip: 'Please input your requirement',
      submit: 'Submit',
    },
  },
  error: {
    http: {
      back: 'Go To Home',
      403: {
        title: '403',
        desc: "Sorry, you don't have access to this page.",
      },
      404: {
        title: '404',
        desc: 'Sorry, the page you visited does not exist or is still under development',
      },
      500: {
        title: '500',
        desc: 'Sorry, the server is wrong.',
      },
    },
    message: {
      confirm: 'Ok',
      401: {
        title: 'Login',
        message: 'Please try logging in again',
      },
      403: {
        title: 'error',
        message: 'You do not have permission to access this data',
      },
      400: {
        title: 'error',
        message: 'Request error, please try again later',
      },
      500: {
        title: 'error',
        message: 'Server error, please try again later',
      },
      unknown: {
        title: 'error',
        message: 'Unknown error, please try again later',
      },
    },
  },
};
